module.exports = __webpack_public_path__ + "static/assets/2594e78913d1bcb7e9ef274297f51d2a.svg";